:host {
    h2.ti-add-to-cart-dialog-title {
        font-size: 28px;
        line-height: 36px;
        margin-bottom: 32px;
        font-weight: 300;
        color: #333;
    }
    ti-dialog {
        p {
            font-size: 14px;
            line-height: 20px;
            margin-top: 0px;
            margin-bottom: 24px;
            font-weight: 400;
        }
    }
}
